import { Theme } from '@mui/material/styles'
import { css } from '@emotion/react'

export const iconBoxStyles = (theme: Theme) => css`
  background-color: ${theme.palette.primary.main + '10'};
  height: 28px;
  width: 28px;
  padding: 4px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const dialogTitleStyles = css`
  font-weight: 700;
  font-size: 18px;
`

export const dialogContentStyles = (theme: Theme) => css`
  background-color: ${theme.palette.grey[50]};
`

export const dialogBoxStyles = (theme: Theme) => css`
  width: 1000px;
  max-width: 100vw;
  outline: none;
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-top: 1px solid ${theme.palette.grey[100]}80;
  ${theme.breakpoints.down('md')} {
    height: 90vh;
  }
`

export const contentAreaStyles = (theme: Theme) => css`
  min-height: ${theme.spacing(20)};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
`
